// Versões dos documentos legais. Quando alterar o texto da política ou termos,
// incremente a versão correspondente — isso força novo aceite no próximo login.
export const PRIVACY_VERSION = "2026-05-27";
export const TERMS_VERSION = "2026-05-27";
export const COOKIES_VERSION = "2026-05-26";

// Dados do controlador (LGPD)
export const CONTROLLER = {
  name: "Leonardo Hallal",
  cnpj: "58.061.171/0001-00",
  dpoEmail: "contato@12personas.com.br",
  dpoName: "Leonardo Hallal",
  forumCity: "São Paulo/SP",
  // SLA de resposta a solicitações LGPD (Art. 19 §1º — prazo razoável)
  rightsSlaDays: 15,
  // Canal único para incidentes / vazamentos
  incidentChannel: "contato@12personas.com.br",
  // Idade mínima (Termos)
  minAge: 18,
} as const;